import React from 'react';
import type { DialType, BaseDialProps } from './types';
import SphereAvatarDial from './SphereAvatarDial';
import StatusDial from './StatusDial';
import TaskDial from './TaskDial';

export interface DialRendererProps extends BaseDialProps {
  /** Which dial type to render */
  dialType: DialType;
}

/**
 * Renders the appropriate dial component based on dialType
 */
const DialRenderer: React.FC<DialRendererProps> = ({
  dialType,
  ...baseProps
}) => {
  switch (dialType) {
    case 'avatar':
      return <SphereAvatarDial type="avatar" {...baseProps} />;
    case 'status':
      return <StatusDial type="status" {...baseProps} />;
    case 'tasks':
      return <TaskDial type="tasks" {...baseProps} />;
    default:
      return <SphereAvatarDial type="avatar" {...baseProps} />;
  }
};

export default DialRenderer;
